module.exports = __webpack_public_path__ + "static/img/about1.ab11c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about1.png
// module id = y9nR
// module chunks = 0